const getDefaultState = () => {
  return {
    lead: {

    },
    org: {

    },
    pc_tabs: [],
    can_manage_staff: false,
    staff: {},
    staff_count: 0
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_ORG (state, payload) {
    state.org = {...(payload || {})}
  },
  SET_LEAD (state, payload) {
    state.lead = {...(payload || {})}
  },
  SET_PC_TABS (state, payload) {
    state.pc_tabs = [...(payload || []) ]
  },
  SET_CAN_MANAGE_STAFF (state, payload) {
    state.can_manage_staff = payload
  },
  SET_STAFF (state, payload) {
    state.staff = {...(payload || {})}
  },
  SET_STAFF_COUNT (state, payload) {
    state.staff_count = payload
  }
}

const actions = {
  // 初始化
  initOrg ({ commit }, org) {
    console.log(org, '000000000000000000')
    commit('SET_ORG', org)
  },
  initLead ({ commit }, lead) {
    console.log(lead, '000000000000000000')
    commit('SET_LEAD', lead)
  },
  initPcTabs ({ commit }, pc_tabs) {
    console.log(pc_tabs, '000000000000000000')
    commit('SET_PC_TABS', pc_tabs)
  },
  initCanManageStaff ({ commit }, can_manage_staff) {
    console.log(can_manage_staff, '000000000000000000')
    commit('SET_CAN_MANAGE_STAFF', can_manage_staff)
  },
  initStaff ({ commit }, staff) {
    console.log(staff, '000000000000000000')
    commit('SET_STAFF', staff)
  },
  initStaffCount ({ commit }, staff_count) {
    console.log(staff_count, '000000000000000000')
    commit('SET_STAFF_COUNT', staff_count)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
